import { CheckCircle2 } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { WebsiteWithImages } from "@/types/prisma";
import type { Service } from "@prisma/client";

// NOTE: not currently in use
const serviceBenefitsSection = {
  type: SECTION_TYPES.SERVICE_BENEFITS,
  content: {
    header: "Service Benefits",
    benefits: [
      {
        title: "Quick Arrival Time",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.",
      },
      {
        title: "Fair Upfront Prices",
        description:
          "Faucibus in ornare quam viverra orci sagittis eu volutpat odio. Ultrices gravida dictum fusce ut. Velit sed ullamcorper morbi tincidunt ornare massa. Aliquam eleifend mi in nulla posuere. ",
      },
      {
        title: "Emergency Repairs",
        description:
          "Quisque id diam vel quam elementum pulvinar etiam non. In vitae turpis massa sed elementum tempus. Sed sed risus pretium quam vulputate. Tortor consequat id porta nibh venenatis cras. ",
      },
      {
        title: "On-Time Guarantee",
        description:
          "Mattis ullamcorper velit sed ullamcorper morbi tincidunt. Quam id leo in vitae turpis massa sed. Sed tempus urna et pharetra pharetra massa. Adipiscing tristique risus nec feugiat in. ",
      },
    ],
  },
  meta: {
    displayName: "Service Benefits",
    displayDescription: "Describe the benefits your service offers.",
    displayIcon: CheckCircle2,
  },
  aiPrompt(service: Service, website: WebsiteWithImages) {
    return `For the Service Benefits section for the service: "${service.name}", blurb: "${service.blurb}" }, industry: ${website.industry}. 
    Highlight the specific advantages and benefits that customers can expect when using the service. 
    Use human-like writing to make the content more appealing and memorable. 
    Focus on the unique selling points that differentiate the service from competitors.
    Limit to 4 benefits. Do not mention anything related to eco-friendliness`;
  },
};

export default serviceBenefitsSection;
